/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React, {useEffect, useState} from "react"

interface Props {
    expect: any
    actual: any
    children?: React.ReactNode | React.ReactNodeArray | React.ReactChildren | React.ReactChild | never[] | never | string | undefined;
}

const IfEqual = (props: Props) =>{
    const [isEqual, setIsEqual] = useState(props.expect == props.actual)

    useEffect(()=>{
        setIsEqual(props.expect == props.actual)
    }, [props.expect, props.actual])

    return (
        isEqual ? (<>
            {props.children}
        </>): (<></>)
    )
}

interface IfTruthyProps {
    val: any
    children?: React.ReactNode | React.ReactNodeArray | React.ReactChildren | React.ReactChild | never[] | never | string | undefined;
}

export const IfTruthy = (props: IfTruthyProps) =>{
    const [isEqual, setIsEqual] = useState(!!props.val)

    useEffect(()=>{
        setIsEqual(props.val)
    }, [props.val, props])

    return (
        isEqual ? (<>
            {props.children}
        </>): (<></>)
    )
}

export {IfEqual}
